import { render } from "./AssigneePicker.vue?vue&type=template&id=470e6b4c&scoped=true"
import script from "./AssigneePicker.vue?vue&type=script&lang=js"
export * from "./AssigneePicker.vue?vue&type=script&lang=js"

import "./AssigneePicker.vue?vue&type=style&index=0&id=470e6b4c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470e6b4c"]])

export default __exports__